var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ydfoot"},[_c('p',[_vm._v("一站式软件开发")]),_c('p',[_vm._v("你身边的软件工程专家！")]),_c('div',{staticClass:"ydfoot_zx"},[_c('p',[_vm._v("马上咨询")]),_c('img',{attrs:{"src":require("../assets/yd_img/yjt2.png"),"alt":""}})])])
}]

export { render, staticRenderFns }